// extracted by mini-css-extract-plugin
module.exports = {"buttonActionsWrapper":"Payables_buttonActionsWrapper__3nogx","buttonActions":"Payables_buttonActions__3TEdG","buttonActionsText":"Payables_buttonActionsText__67k8d"};